import Header from "./components/header/header";
import MainBlock from "./components/main-block/main-block";
import About from "./components/about/about";

import TableBlock from "./components/table-block/table-block";
import InfoBlock from "./components/info-block/info-block";
import PriceBlock from "./components/price-block/price-block";
import ContactBlock from "./components/contact-block/contact-block";
import Footer from "./components/footer/footer";


function App() {
    return (
        <>
            <Header/>
            <MainBlock/>
            <About />
            <TableBlock />
            <InfoBlock />
            <PriceBlock />
            <ContactBlock />
            <Footer />
        </>
    );
}

export default App;
